import _asyncToGenerator from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import axios from 'axios';
import Notify from 'quasar/src/plugins/Notify.js';;
import _ from 'lodash';
export default /*#__PURE__*/(function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(context) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          context.Vue.prototype.$axios = axios.create({
            baseURL: process.env.SERVER_URL,
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            }
          });
          // const token = localStorage.getItem('access_token')
          // const token = context.$q.cookies.get('access_token')
          //
          // if (token) {
          //   context.Vue.prototype.$axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
          // }
          context.Vue.prototype.$axios.interceptors.response.use(function (response) {
            return response;
          }, function (error) {
            if (error.response && error.response.status === 422) {
              Notify.create(_.first(error.response.data.errors[_.first(Object.keys(error.response.data.errors))]));
            } else if (error.response && error.response.status === 404) {
              // Notification not necessary
              // Notify.create('Risorsa non trovata.')
            } else {
              Notify.create('Ops, qualcosa è andato storto. Riprova.');
            }
            return Promise.reject(error);
          });
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref.apply(this, arguments);
  };
})();